import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';

import styles from './DataSourcesCta.module.scss';

export const DataSourcesCta = () => {
  const { t } = useInt();

  return (
    <Section className={styles.root}>
      <div className={styles.note}>
        <span className={styles.noteGrid} aria-hidden="true" />

        <div className={styles.noteBody}>
          <div className={styles.noteHead}>
            <span className={styles.noteIcon}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            </span>

            <div>
              <span className={styles.noteEyebrow}>{t('Data Provenance')}</span>
              <h4 className={styles.noteTitle}>{t('About our data sourcing')}</h4>
            </div>
          </div>

          <p className={styles.noteText}>
            {t(
              'Global Database collects company information directly from 400+ official government registries and tax authorities worldwide. Data is refreshed daily, with financial filings and corporate changes typically reflected within 24 hours. For US and Canadian coverage, we source from each individual state and provincial registry respectively.',
            )}
          </p>
        </div>
      </div>

      <div className={styles.cards}>
        <div className={cn(styles.card, styles.cardPrimary)}>
          <span className={styles.glow} aria-hidden="true" />
          <svg
            className={styles.ghostIcon}
            width="140"
            height="140"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            aria-hidden="true"
          >
            <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
            <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
            <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
            <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
          </svg>

          <div className={styles.head}>
            <span className={styles.icon}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
                <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
                <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
                <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
              </svg>
            </span>

            <span className={styles.eyebrow}>{t('Get started')}</span>
          </div>
          <h3 className={styles.title}>{t('Get Platform Access or API')}</h3>
          <p className={styles.text}>
            {t(
              'Search company profiles, financials, and ownership structures across 200+ jurisdictions. No credit card required.',
            )}
          </p>
          <a className={styles.linkPrimary} href="/free-trial">
            {t('Start Free Trial')}
            <span className={styles.linkArrow}>
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </span>
          </a>
        </div>

        <div className={cn(styles.card, styles.cardEnterprise)}>
          <svg
            className={styles.ghostIcon}
            width="140"
            height="140"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            aria-hidden="true"
          >
            <path d="M3 21h18" />
            <path d="M5 21V7l8-4v18" />
            <path d="M19 21V11l-6-4" />
            <path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01" />
          </svg>

          <div className={styles.head}>
            <span className={styles.icon}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 21h18" />
                <path d="M5 21V7l8-4v18" />
                <path d="M19 21V11l-6-4" />
              </svg>
            </span>

            <span className={styles.eyebrow}>{t('Enterprise')}</span>
          </div>
          <h3 className={styles.title}>{t('Request Bulk Data Feed')}</h3>
          <p className={styles.text}>
            {t(
              'License our full registry dataset via API or flat file delivery. Includes source attribution, commercial reseller rights, and dedicated support.',
            )}
          </p>
          <a className={styles.linkSecondary} href="/book-a-demo">
            {t('Talk to Sales')}
            <span className={styles.linkArrow}>
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </span>
          </a>
        </div>
      </div>
    </Section>
  );
};
